import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import MediumButton from "components/ProjectSpecificComponents/Elements/Global/atoms/Buttons/MediumButton"
import { observer } from "mobx-react"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {
	mobileView?: boolean
}

/**
 * Opens setting modal for email config and personalize
 */
const SettingsButton = observer(({ mobileView = false }: Props) => {
	const store = useStore()
	const { t } = useTranslation()
	const formStore = useFormStore()

	const _onClick = () => {
		formStore.savePersonalizeSettingsForHistory()
		store.setShowAdminSettingsModal(true)
	}

	return (
		<MediumButton
			style={{
				color: mobileView
					? "var(--muddy-puddle-gray)"
					: formStore.settingsData.personalize.colorHeaderText ?? "var(--blue)",
				background: "none",
				fontSize: mobileView ? "12px" : "14px",

				fontWeight: mobileView ? 400 : 600,
			}}
			borderless
			onClick={_onClick}
			children={t("rawText.settings")}
		/>
	)
})

export default SettingsButton
